export const APPLICATION_TYPE = {
    INDIVIDUAL: 'I',
    JOINT: 'J',
};
